import {ComponentType, lazy, ReactNode, Suspense as ReactSuspense} from 'react';

import Loading from 'components/base/Loading';

interface IBaseLoadable {
  loader: () => Promise<{
    default: ComponentType<any>;
  }>;
}

export const Suspense = ({children}: {children: ReactNode}) => (
  <ReactSuspense fallback={<Loading />}> {children} </ReactSuspense>
);

const BaseLoadable = ({loader}: IBaseLoadable) => lazy(loader);

export default BaseLoadable;
